// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TReferralGetListingModel, IMappers, TReferralGetListingResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetReferralsListingResponse } from '../../../entities/v1_get_referrals_listing/V1GetReferralsListingResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createReferralGetListingModel(): TReferralGetListingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cpd',
    pathApi: '/v1/referral/get-listing/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IReferralGetListingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchReferralGetListing<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IReferralGetListingOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TReferralGetListingResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createReferralGetListingModel(),
    config,
  )) as FetchResponse<TReferralGetListingResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetReferralsListingResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TReferralGetListingResponse>;
}
